import debug from "@cher-ami/debug"
import { Component, Stack } from "~/libs/compose"
import { Timeline } from "@wbe/interpol"
import Logo from "../logo/Logo"

const componentName = "Header"
const log = debug(`front:${componentName}`)

type TStaticProps = {}

/**
 * @name Header
 */
export default class Header extends Component<TStaticProps> {
	static attrName = "Header"

	private lastScrollPosition: number = 0
	private isHeaderVisible: boolean = true
	private readonly SCROLL_THRESHOLD: number = 40

	public logo = this.add(Logo)

	public elements = {
		$container: this.find<HTMLElement>("container"),
		$nav: this.find<HTMLElement>("nav")
	}

	// ----------------------------------------------------------------------------- LIFECYCLE

	mounted() {
		log("> mounted")
		this.attachEvents()
	}

	unmounted() {
		log("> unmounted")
		this.detachEvents()
	}

	// ----------------------------------------------------------------------------- EVENTS

	// Add a logic to add a class ".has-background" to the header when the user scroll
	attachEvents() {
		window.addEventListener("scroll", this.onScroll.bind(this))
	}

	detachEvents() {
		window.removeEventListener("scroll", this.onScroll.bind(this))
	}

	onScroll() {
		const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop

		// Check if we've scrolled past the threshold and if we're scrolling down
		if (
			currentScrollPosition > this.lastScrollPosition &&
			currentScrollPosition > this.SCROLL_THRESHOLD - 20
		) {
			// Hide the header
			if (this.isHeaderVisible) {
				this.elements.$container.classList.remove("visible")
				this.isHeaderVisible = false
			}
		} else {
			// Show the header
			if (!this.isHeaderVisible) {
				this.elements.$container.classList.add("visible")
				this.isHeaderVisible = true
			}
		}

		// Update the last scroll position
		this.lastScrollPosition = currentScrollPosition

		if (window.scrollY > this.SCROLL_THRESHOLD) {
			this.elements.$container.classList.add("has-background")
		} else {
			this.elements.$container.classList.remove("has-background")
		}
	}

	// ----------------------------------------------------------------------------- ANIMATION

	override playIn(delay): void {
		this.logo.playIn(200)
		// Create a timeline instance
		const tl = new Timeline()
		;[this.elements.$nav].forEach((el) =>
			tl.add(
				{
					el,
					props: {
						y: [155, 0, "%"]
					},
					duration: 700,
					ease: "power3.out"
				},
				delay
			)
		)
	}
}
